<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="detailDialog"
        persistent
        max-width="600px"
        scrollable
      >
        <v-card style="border-radius: 8px">
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            >
              <span class="headline">{{ $t('finance.transactionDetailTitle') }}</span>
            </v-flex>
            <v-flex xs1>
              <v-btn
                flat
                icon
                class="close"
                @click="$emit('close')"
              >
                <span aria-hidden="true">
                  <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
                </span>
              </v-btn>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <table class="detail-table">
              <tbody>
                <tr>
                  <td class="section-title" colspan="2">{{ $t('finance.transactionInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.id') }}</b></td>
                  <td>{{ instance.bank_transaction_id }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.bankName') }}</b></td>
                  <td>{{ instance.bank_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.description') }}</b></td>
                  <td>{{ instance.description }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.amount') }}</b></td>
                  <td>{{ instance.actual_cost }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.credit') }}</b></td>
                  <td style="color: #2e7d32">{{ instance.credit }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.debit') }}</b></td>
                  <td style="color: #c62828">{{ instance.debit }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title" colspan="2">{{ $t('finance.classificationSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.transactionType') }}</b></td>
                  <td>
                    <v-chip
                      v-if="instance.transaction_type"
                      small
                      label
                      :color="getTypeColor(instance.transaction_type)"
                      outline
                    >
                      {{ formatType(instance.transaction_type) }}
                    </v-chip>
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.status') }}</b></td>
                  <td>
                    <v-chip
                      v-if="instance.status"
                      small
                      label
                      :color="getStatusColor(instance.status)"
                      outline
                    >
                      {{ instance.status }}
                    </v-chip>
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.verified') }}</b></td>
                  <td>
                    <v-chip
                      small
                      label
                      :color="instance.verified ? 'green' : 'grey'"
                      outline
                    >
                      {{ instance.verified ? $t('common.yes') : $t('common.no') }}
                    </v-chip>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title" colspan="2">{{ $t('finance.sourceInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.source') }}</b></td>
                  <td>{{ instance.model_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.sourceId') }}</b></td>
                  <td>{{ instance.model_id }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title" colspan="2">{{ $t('finance.datesAndStaffSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.staff') }}</b></td>
                  <td>{{ instance.full_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.transactionDate') }}</b></td>
                  <td>{{ instance.transaction_date }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.createdAt') }}</b></td>
                  <td>{{ instance.created_at }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.updatedAt') }}</b></td>
                  <td>{{ instance.updated_at }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="$emit('close')"
              outline
              small
              class="py-1 px-2"
            >
              {{ $t('common.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: [
    'detailDialog',
    'instance'
  ],
  methods: {
    getStatusColor: function (status) {
      var colors = {
        paid: 'green',
        unpaid: 'grey',
        pending: 'orange',
        cancel: 'red',
        refunded: 'blue',
        partial_refunded: 'purple'
      }
      return colors[status] || 'grey'
    },
    getTypeColor: function (type) {
      var colors = {
        order: 'blue',
        money_transfer: 'teal',
        expense: 'orange',
        credit_invoice: 'green',
        cash_back: 'purple',
        digital_payment: 'indigo'
      }
      return colors[type] || 'grey'
    },
    formatType: function (type) {
      if (!type) return ''
      return type.replace(/_/g, ' ')
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.detail-table .section-title {
  padding-left: 0px;
  padding-top: 0px;
  opacity: 0.7;
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  color: #006b8d;
}

.detail-table tr td {
  padding: 3px 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/bankTransactions/viewBankTransaction.vue